let keySeq = 0

export function nextCellKey() {
    keySeq += 1
    return `colorant-cell-${keySeq}`
}
